import React, { useState, useEffect } from "react";
import { useContext } from "react";
import { CartContext } from "./CartContext";  

import { Link, useLocation } from "react-router-dom";
import logoImage from "../image/dharajlogo.jpeg";
import { IoBagHandleOutline } from "react-icons/io5";
import { FaSearch, FaTimes, FaUserTie } from "react-icons/fa";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [activeTab, setActiveTab] = useState("categories");
  const { cartCount } = useContext(CartContext);


  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleSearch = () => setShowSearch(!showSearch);

  const location = useLocation();
  const hideNavbarRoutes = ["/cart", "/AuthLogin" ,"/CheckOut/:status" ,"/PaymentSummary"];
  const hideNavbar = hideNavbarRoutes.includes(location.pathname);

  useEffect(() => {
    document.body.style.overflow = menuOpen || showSearch ? "hidden" : "auto";
  }, [menuOpen, showSearch]);

  return (
    <>
      {!hideNavbar && (
        <>
          <style>{`
            /* ---------------- TOP BANNER ---------------- */
            .top-banner {
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              background-color: #185E37;
              color: #fff;
              text-align: center;
              font-weight: 500;
              font-size: 15px;
              padding: 10px 0;
              z-index: 1100;
            }
            .marquee {
              display: flex;
              width: max-content;
              animation: marquee 25s linear infinite;
            }
            .marquee span {
              padding-right: 100px;
              white-space: nowrap;
            }
            @keyframes marquee {
              from { transform: translateX(0); }
              to { transform: translateX(-50%); }
            }

            /* ---------------- NAVBAR ---------------- */
            .navbar {
              position: fixed;
              top: 41px;
              left: 0;
              width: 100%;
              background: #fff;
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 8px 60px;
              box-shadow: 0 3px 10px rgba(0,0,0,0.15);
              z-index: 1000;
            }

            .logo img {
              height: 55px;
              width: auto;
            }

            body {
              padding-top: 110px;
            }

            /* ---------------- NAV LINKS ---------------- */
            .nav-links {
              display: flex;
              gap: 25px;
              align-items: center;
              list-style: none;
            }
            .nav-links a, .nav-links span {
              text-decoration: none;
              font-size: 16px;
              font-weight: 500;
              color: #000;
              transition: color 0.3s ease;
            }
            .nav-links a:hover, .nav-links span:hover {
              color: #185E37;
            }

            /* ---------------- RIGHT ICONS ---------------- */
            .right-icons {
              display: flex;
              align-items: center;
              gap: 12px;
            }
            .right-icons .icon {
              font-size: 22px;
              cursor: pointer;
              color: #185E37;
            }
              .right-icons .icon:hover,
              .right-icons a:hover,
              .right-icons i:hover,
              .right-icons svg:hover {
                color: #185E37 !important;   /* keep original color */
                background: none !important;
                transform: none !important;
                opacity: 1 !important;
              }
              

            /* ---------------- CART ICON ---------------- */
            .cart-icon {
              position: relative;
              font-size: 25px;
              color: #185E37;
              display: flex;
              align-items: center;
              cursor: pointer;
            }
            .cart-count {
              position: absolute;
              top: -6px;
              right: -8px;
              background: red;
              color: #fff;
              border-radius: 50%;
              font-size: 12px;
              padding: 2px 5px;
            }

            /* ---------------- DROPDOWN ---------------- */
            .nav-links li {
              position: relative;
            }
            .dropdown-menu {
              position: absolute;
              top: 35px;
              left: 0;
              background-color: #ffffff;
              color: #185E37;
              list-style: none;
              padding: 10px 0;
              width: 200px;
              border-radius: 8px;
              box-shadow: 0 4px 10px rgba(0,0,0,0.15);
              display: none;
              z-index: 2000;
            }
            .dropdown-menu li {
              padding: 8px 16px;
            }
            .dropdown-menu li a {
              color: #185E37;
              text-decoration: none;
              display: block;
            }
            .dropdown-menu li:hover {
              background-color: #e8f5e9;
            }
            .dropdown:hover .dropdown-menu {
              display: block;
            }

            /* ---------------- MOBILE SIDEBAR ---------------- */
            .mobile-sidebar {
              position: fixed;
              top: 0;
              left: -100%;
              width: 85%;
              max-width: 400px;
              height: 100vh;
              background: #fff;
              box-shadow: 6px 0 30px rgba(0,0,0,0.3);
              border-radius: 0 20px 20px 0;
              transition: left 0.4s ease;
              z-index: 1300;
              display: flex;
              flex-direction: column;
              padding-top: 20px;
            }
            .mobile-sidebar.open { left: 0; }

            .cancel-btn {
              position: absolute;
              top: 20px;
              right: -45px;
              background: #e53935;
              color: #fff;
              border: none;
              border-radius: 50%;
              width: 40px;
              height: 40px;
              font-size: 20px;
              cursor: pointer;
              box-shadow: 0 4px 12px rgba(0,0,0,0.4);
              z-index: 1400;
            }

            .sidebar-header {
              display: flex;
              border-bottom: 1px solid #ddd;
              margin: 0 10px;
            }
            .sidebar-header .tab {
              flex: 1;
              padding: 14px;
              text-align: center;
              background: #f5f5f5;
              border: none;
              font-weight: 700;
              font-size: 14px;
              cursor: pointer;
              border-radius: 8px 8px 0 0;
              margin: 0 5px;
              transition: background 0.3s ease;
            }
            .sidebar-header .tab.active {
              background: #fff;
              border-bottom: 3px solid #185E37;
            }
            .sidebar-content {
              padding: 15px 0;
              flex: 1;
              overflow-y: auto;
            }
            .sidebar-content li {
              padding: 14px 20px;
              margin: 8px 14px;
              border-radius: 10px;
              display: flex;
              align-items: center;
              font-size: 18px;
              font-weight: 500;
              background: #fff;
              box-shadow: 0 2px 6px rgba(0,0,0,0.1);
              color: #000;
            }
            .sidebar-content li:hover {
              background-color: #f1f8f3;
            }

            /* ---------------- SEARCH DRAWER ---------------- */
            .search-drawer {
              position: fixed;
              top: 0;
              right: -100%;
              width: 400px;
              max-width: 90%;
              height: 100%;
              background: #fff;
              box-shadow: -5px 0 20px rgba(0,0,0,0.2);
              z-index: 1300;
              transition: right 0.4s ease;
              padding: 30px;
              display: flex;
              flex-direction: column;
            }
            .search-drawer.active { right: 0; }
            .search-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
            }
            .search-header h3 { font-size: 18px; font-weight: 700; }
            .search-close { font-size: 24px; cursor: pointer; color: #185E37; }
            .search-box {
              display: flex;
              align-items: center;
              border: 1px solid #ccc;
              border-radius: 6px;
              padding: 5px 10px;
              margin-bottom: 15px;
            }
            .search-box input {
              flex: 1;
              border: none;
              outline: none;
              font-size: 15px;
            }
            .quick-search a {
              color: #185E37;
              text-decoration: none;
              margin-right: 6px;
              cursor: pointer;
              font-weight: 500;
            }

            /* ---------------- OVERLAY ---------------- */
            .overlay {
              position: fixed;
              inset: 0;
              background: rgba(0,0,0,0.4);
              z-index: 1200;
            }

            /* ---------------- RESPONSIVE ---------------- */
            @media (max-width: 768px) {
              .navbar { padding: 8px 35px; }
              .logo img { height: 45px; }
              .nav-links { display: none; }
              .menu-icon { display: block; cursor: pointer; }
              .cart-icon { display: none; }
              .cart-iconn { display: none; }
               


            }
            @media (min-width: 769px) {
              .menu-icon { display: none; }
            }
          `}</style>

          {/* ---------------- TOP BANNER ---------------- */}
          <div className="top-banner">
            <div className="marquee">
              <span>🎉 Flat 2% Off On All Products | 🚚 Free Shipping Above ₹999 | 🌿 100% Natural & Pure Products</span>
              <span>🎉 Flat 2% Off On All Products | 🚚 Free Shipping Above ₹999 | 🌿 100% Natural & Pure Products</span>
            </div>
          </div>

          {/* ---------------- NAVBAR ---------------- */}
          <nav className="navbar">
            {/* Menu Icon */}
            <div className="menu-icon" onClick={toggleMenu}>
              {menuOpen ? (
                <FaTimes size={24} color="#000" />
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#2A431C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="3" y1="6" x2="25" y2="6" />
                  <line x1="3" y1="12" x2="15" y2="12" />
                  <line x1="3" y1="18" x2="25" y2="18" />
                </svg>
              )}
            </div>

            {/* Logo */}
            <div className="logo">
              <Link to="/"><img src={logoImage} alt="Logo" /></Link>
            </div>

            {/* Navbar Links */}
            <ul className="nav-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/allproducts/:categoryid">All Product</Link></li>


              <li className="dropdown">
                <span>Best Selling</span>
                <ul className="dropdown-menu">
                  <li><Link to="/product/rasgulla">Rasgulla</Link></li>
                  <li><Link to="/product/gulab-jamun">Gulab Jamun</Link></li>
                  <li><Link to="/product/soan-papdi">Soan Papdi</Link></li>
                  <li><Link to="/product/barfi">Barfi</Link></li>
                  <li><Link to="/product/ladoo">Ladoo</Link></li>
                </ul>
              </li>

              <li className="dropdown">
                <span>Dharaj Special</span>
                <ul className="dropdown-menu">
                  <li><Link to="/product/kaju-katli">Kaju Katli</Link></li>
                  <li><Link to="/product/besan-ladoo">Besan Ladoo</Link></li>
                  <li><Link to="/product/motichoor-ladoo">Motichoor Ladoo</Link></li>
                  <li><Link to="/product/dharaj-delight">Dharaj Delight</Link></li>
                  <li><Link to="/product/chocolate-bites">Chocolate Bites</Link></li>
                </ul>
              </li>

              
                <li><Link to="/Blog ">Blog</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>

          
          {/* ---------------- Right Icons---------------- */}

            <div className="right-icons">
              
             <i className="bi bi-search icon " onClick={toggleSearch}   style={{ color: "#298b31", fontSize: "20px" , marginTop: "3px" }}></i>

              <Link to="/AuthLogin" className="cart-iconn" style={{ fontSize: "26px", marginTop: "5px", color: "#298b31" }}>
                <i className="bi bi-person"></i>
              </Link>
             <Link to="/Cart" className="cart-icon">
  <IoBagHandleOutline />
  {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
</Link>

            </div>
          </nav>

          {/* ---------------- MOBILE SIDEBAR ---------------- */}
          <div className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
            <button className="cancel-btn" onClick={toggleMenu}>×</button>

            <div className="sidebar-header">
              <button
                className={`tab ${activeTab === "categories" ? "active" : ""}`}
                onClick={() => setActiveTab("categories")}
              >
                Categories
              </button>
              <button
                className={`tab ${activeTab === "menu" ? "active" : ""}`}
                onClick={() => setActiveTab("menu")}
              >
                Menu
              </button>
            </div>

           <div className="sidebar-content">
  {activeTab === "categories" ? (
    <ul>
      <li>
        <Link to="/allproducts/:categoryid=Best%20Selling">🔥 Best Selling</Link>
      </li>

      <li>
        <Link to="/allproducts/:categoryid=Dharaj%20Special">💚 Dharaj Special</Link>
      </li>

      <li>
        <Link to="/allproducts/:categoryid=Honey">🍯 Honey</Link>
      </li>

      <li>
        <Link to="/allproducts/:categoryid=Spices">🌿 Spices</Link>
      </li>

      <li>
        <Link to="/allproducts/:categoryid=Sanitary">🧴 Sanitary</Link>
      </li>

      <li>
        <Link to="/allproducts/:categoryid=Special%20Combo">🎁 Special Combo</Link>
      </li>
    </ul>
  ) : (
    <ul>
      <li>
        <Link to="/AuthLogin">
          <FaUserTie size={22} /> My Account
        </Link>
      </li>
      <li><Link to="/about">About Us</Link></li>
      <li><Link to="/contact">Contact Us</Link></li>
      <li><Link to="/Blog">Blog</Link></li>
    </ul>
  )}
</div>

          </div>

          {/* ---------------- SEARCH DRAWER ---------------- */}
          <div className={`search-drawer ${showSearch ? "active" : ""}`}>
            <div className="search-header">
              <h3>SEARCH OUR SITE</h3>
              <FaTimes className="search-close" onClick={toggleSearch} />
            </div>

            <div className="search-box">
              <input type="text" placeholder="Search..." />
              <FaSearch />
            </div>

            <div className="quick-search">
              Quick search:{" "}
              {["Rice", "Millets", "Ghee", "Honey", "Spices", "Oil", "Snacks"].map((term, i) => (
                <a key={i}>{term}</a>
              ))}
            </div>
          </div>

          {/* ---------------- OVERLAY ---------------- */}
          {(menuOpen || showSearch) && (
            <div
              className="overlay"
              onClick={() => {
                setMenuOpen(false);
                setShowSearch(false);
              }}
            ></div>
          )}
        </>
      )}
    </>
  );
};

export default Header;
